export enum SubscriptionErrorCodes {
  UserNotFound = 'user_not_found',
  SubscriptionsLimitReached = 'subs_limit_reached',
  TelegramNotLinked = 'telegram_account_not_linked',
  InvalidMake = 'invalid_make_provided',
  InvalidModel = 'invalid_make_provided',
  SubscriptionAlreadyExists = 'subscription_already_exists',
}
